import { useCallback, useMemo, useRef } from "react";
import apiClient from "../../utils/api";

const useGetPdfById = () => {
  const cache = useRef(new Map<string, any>());

  const getPdfById = useCallback(async (pdfId: string) => {
    if (cache.current.has(pdfId)) {
      return cache.current.get(pdfId);
    }

    const res = await apiClient.documentControllerRetrieveDocument({
      chunkRequest: {
        id: pdfId,
      },
    });

    cache.current.set(pdfId, res.document);
    return res.document;
  }, []);

  const memoizedGetPdfById = useMemo(() => getPdfById, [getPdfById]);

  return memoizedGetPdfById;
};

export default useGetPdfById;
